'use client'
import { setCompanySector } from '@/app/globalRedux/filter/companyFilter'
import {
  setProductOrder,
  setProductSector,
  setProductSelectedSortOption,
} from '@/app/globalRedux/filter/productFilter'
import { RootState } from '@/app/globalRedux/store'
import { useTranslation } from '@/app/i18n/client'
import SearchResultSort from '@/components/SearchResultSelect'
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from '@/components/ui/accordion'
import { Label } from '@/components/ui/label'
import { RadioGroup, RadioGroupItem } from '@/components/ui/radio-group'
import { closeModal } from '@/lib/filterMobileModalHandler'
import CloseIcon from '@mui/icons-material/Close'
import Skeleton from '@mui/material/Skeleton/Skeleton'
import React, { useEffect, useMemo, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import ClearAllFilter from '../CommonFilters/ClearAllFilter'
import ProductFruitVegtableFilter from './ProductFruitVegtableFilter'
import ProductPrePostFilter from './ProductPrePostFilter'
import ProductTransportLogistics from './ProductTransportLogistics'
import { usePageNumberUpdator } from '@/app/hooks/usePageParamUpdater'

const ProductFilter = () => {
  const { t } = useTranslation()
  const dispatch = useDispatch()
  const goToPage = usePageNumberUpdator()
  const { order: productOrder, productSelectedSortOption } = useSelector(
    (state: RootState) => state.productFilter
  )
  const productFilter = useSelector((state: RootState) => state.productFilter)
  const [isMounted, setIsMounted] = useState(false)

  const sectors = [
    {
      value: 'Fruit & Vegetable',
      filterComponent: <ProductFruitVegtableFilter />,
    },
    { value: 'Pre - Post Harvest', filterComponent: <ProductPrePostFilter /> },
    {
      value: 'Transport / Logistics',
      filterComponent: <ProductTransportLogistics />,
    },
  ]
  const selectedFilterComponent = useMemo(() => {
    return sectors.find((item) => item.value === productFilter.sector)
      ?.filterComponent
  }, [sectors, productFilter.sector])

  const handleSectorChange = (value: string) => {
    if (value) {
      dispatch(setProductSector(value))
      dispatch(setCompanySector(value))
      goToPage({ newPageNo: 1 })
    }
  }
  useEffect(() => {
    setIsMounted(true)
  }, [])
  if (!isMounted) {
    return <Skeleton variant="rectangular" width={210} height={1000} />
  }

  return (
    <div className="w-[299px] mobile:w-[360px]">
      <div>
        <div className="text-[16px] px-[15px] py-[10px] shadow-[0_0_3px_0_rgba(0,0,0,0.06)] bg-[#fafafa] border border-solid border-[#ebebeb] w-full flex rounded-[4px]">
          <ClearAllFilter />
          <span className="hidden mobile:block mobile:ms-2">
            <CloseIcon
              onClick={() => {
                closeModal('product-modal')
              }}
            />
          </span>
        </div>
      </div>
      <span className=" hidden mobile:block  mt-3">
        <SearchResultSort
          options="productSort"
          selectedOption={productSelectedSortOption}
          sortByFunction={(value) => {
            dispatch(setProductSelectedSortOption(value))
          }}
          order={productOrder}
          orderByFunction={(value) => {
            dispatch(setProductOrder(value))
          }}
        />
      </span>
      <div className="shadow-[0_0_3px_0_rgba(0,0,0,0.06)] bg-neutral-50 border border-solid border-[#ebebeb] mt-[20px] rounded-[4px] mobile:mt-[10px]">
        <div>
          <Accordion type="single" collapsible defaultValue="item-1">
            <AccordionItem value="item-1">
              <AccordionTrigger>
                <span className="text-[18px] font-semibold text-[#222]">
                  {t('Sector')}
                </span>
              </AccordionTrigger>
              <AccordionContent>
                <div className="flex flex-col ">
                  {
                    <RadioGroup
                      defaultValue={'Fruit & Vegetable'}
                      className="flex gap-4 items "
                      id="product_type"
                      onClick={(e: React.MouseEvent<HTMLInputElement>) => {
                        const value = (e.target as HTMLInputElement).value
                        handleSectorChange(value)
                      }}
                    >
                      <div className=" flex flex-col gap-2 checked-color">
                        {sectors.map(
                          (sector: {
                            value: string
                            filterComponent: React.ReactNode
                          }) => (
                            <Label
                              key={sector?.value}
                              htmlFor={sector?.value}
                              className="flex   gap-2  text-sm  not-italic leading-[normal] tracking-[normal] text-left text-[#6f6f6f]"
                            >
                              <RadioGroupItem
                                value={sector.value}
                                className=" !text-[#df7d2f] cursor-pointer"
                                id={sector.value}
                                checked={sector?.value == productFilter.sector}
                              />
                              {t(sector?.value)}
                            </Label>
                          )
                        )}
                      </div>
                    </RadioGroup>
                  }
                </div>
              </AccordionContent>
            </AccordionItem>
          </Accordion>
        </div>
      </div>

      {selectedFilterComponent}
    </div>
  )
}

export default ProductFilter
